import { JSX, useCallback, useEffect } from 'react';
import { Platform } from 'react-native';
import { Link } from '../../../components/core';
import { useNavigateToPatientPortal } from '../../../hooks/useNavigateToPatientPortal';
import { errorLink } from '../../../plugins/apolloSetup';
import { useCurrentRouteSearch } from '../../../routes';
import { AuthErrorComponent } from '../../authentication/components/AuthError';

const TWO_SECONDS_MS = 2000;

export const UserMustGoToPatientPortal = (): JSX.Element => {
  const searchParams = useCurrentRouteSearch();
  const { navigateToPatientPortal } = useNavigateToPatientPortal();

  const handleRedirect = useCallback(() => {
    navigateToPatientPortal({
      mrn: searchParams.mrn,
      handleErrorsInCallback: true,
      onError: (errorType?: string) => {
        if (errorType === 'VerifyEligibility') {
          errorLink.onBlockedError('verifyEligibility');
          return;
        }
        if (errorType === 'NoClinicalSelfReferral') {
          errorLink.onBlockedError('noSelfRefer');
        }
      },
    });
  }, [navigateToPatientPortal, searchParams.mrn]);

  useEffect(() => {
    const timer = setTimeout(handleRedirect, TWO_SECONDS_MS);
    return () => clearTimeout(timer);
  }, []); // Empty dependency array to run only once on mount

  const errorType = Platform.OS === 'web' ? 'toPatientPortal' : 'toPatientPortalMobile';

  return (
    <AuthErrorComponent errorType={errorType}>
      If you are not redirected in a few seconds,{' '}
      <Link.para bold to="" onPress={handleRedirect}>
        click here
      </Link.para>{' '}
      to be redirected.
    </AuthErrorComponent>
  );
};
